import React, { useEffect, useState } from "react";
import ExclamationIcon from "../../../assets/img/exclamation-mark-icon.svg";
import { useDispatch } from "react-redux";
import { saveNoEmploymentReason } from "../../../Actions/employementActions_v2";
const TenureAlertPopUp = React.forwardRef((props, ref) => {
  const {
    showModalBox,
    record,
    title,
    description,
    isAdd,
    checkStatus,
    closePopup,
    proceedHandler,
    addEmploymentHandler,
    employmentReason,
    currentCheck
  } = props;

  const dispatch = useDispatch();

  const [checkBoxValue, setCheckBoxValue] = useState(false);
  const [noEmploymentReason, setNoEmploymentReason] = useState("");
  const [reasonError, setReasonError] = useState(false);

  useEffect(() => {
    if (employmentReason) {
      setNoEmploymentReason(employmentReason);
    }
  }, [employmentReason]);
  

  const closePopupHandler = () => {
    closePopup();
  };

  const onClickProceed = async (e) => {
    e.preventDefault();
    if(noEmploymentReason) {
        await dispatch(saveNoEmploymentReason({emp_reason : noEmploymentReason, case_check_id : currentCheck?.case_check_id}))
        proceedHandler();
    } else {
        setReasonError(true);
    }
  };

  const handleOnCheckChange = (e) => {
    // e?.preventDefault();
    setCheckBoxValue(e?.target?.checked);

    const temp = {
      "msg": "We have identified overlap in the duration of work between the employments entered. Please verify your details and ensure there is no overlap in the duration of work for the mentioned employments.",
      "valid": "0",
      "add_emp": "0",
      "etype": "Overlapping Employments!",
      "show_gap": "0",
      "type": "validation"
  }
  };

  console.log("des", description);
  return (
    <>
      <div
        className={
          "dashboard custom-modal-dialog " +
          (showModalBox === 1 ? "show" : "hidden")
        }
        onClick={closePopupHandler}
      >
        <div
          className="modal-wrapper"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div
            className="modal-content p-4 no-scroll"
            style={{ maxWidth: "370px" }}
          >
            <div className="text-left">
              <img src={ExclamationIcon} alt="" />
              <h5 className="mt-3">{title}</h5>
              <span className="cstm-popup-close-btn" style={{backgroundColor:"white", color: "#6c757d", top: 6, right: 6}} onClick={closePopup}>
              &times;
            </span>
              <p className="text-muted">{`Requirement is not met. ${description}`}</p>
            </div>
            <div className="d-inline-flex align-items-center">
              <div className="form-group">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="noEmp"
                    id={"noEmp"}
                    onChange={(e) => handleOnCheckChange(e)}
                    checked={checkBoxValue}
                  />
                  <label
                    htmlFor={"no_further_emp"}
                    className="form-check-label"
                    style={{ fontWeight: 600 }}
                  >
                    {"I do not have further employment"}
                  </label>
                </div>
              </div>
            </div>
            {checkBoxValue && (
                <>
                <div class="form-group mb-0 floating-label">
                <input
                  id="tenure_reason"
                  type="text"
                  class="form-control"
                  // placeholder="Enter Reason"
                  value={noEmploymentReason}
                  onChange={(e) => {
                    setNoEmploymentReason(e?.target?.value)
                    setReasonError(false);
                  }}
                />
                 <label htmlFor={"tenure_reason"} className={noEmploymentReason && "focused"}>
              {'Reason'}
              {<sup className="text-danger">*</sup>}
            </label>
              </div>
              {reasonError == true ? (
                noEmploymentReason == "" || noEmploymentReason == null ? (
                  <p className="err text-danger">This field is required</p>
                ) : (
                  <p className="err text-danger">Please provide valid input</p>
                )
              ) : (
                <></>
              )}
                </>
            )}
            <div className="row">
              <div className="col-md-12 d-flex justify-content-between">
                <button
                  className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2"
                  onClick={onClickProceed}
                  disabled={!checkBoxValue}
                >
                  Proceed
                </button>
                <button
                  className={"btn btn-primary btn-lg btn-block mt-3"}
                  onClick={(e) => addEmploymentHandler(e)}
                  disabled={checkBoxValue}
                >
                  + Add Employment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default TenureAlertPopUp;
